import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getApi } from '../services/apiServices';

function Partnerships() {
  const { t } = useTranslation();

  return (  
    <>
  <section className="faq terms-nd-condition">
   <div className='container'>
  <h2 className='inner-heading'>{t('partnerships.title')}</h2>
  <p>
    {t('partnerships.description')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('partnerships.whyPartner.title')}</h3>
  <ul className='terms-list'>
    <li><strong>{t('partnerships.whyPartner.attractiveMargins')}</strong></li>
    <li><strong>{t('partnerships.whyPartner.scalableSolutions')}</strong></li>
    <li><strong>{t('partnerships.whyPartner.globalReach')}</strong></li>
    <li><strong>{t('partnerships.whyPartner.reliableSupport')}</strong></li>
  </ul>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('partnerships.waysToPartner.title')}</h3>
  <ul className='terms-list'>
    <li>{t('partnerships.waysToPartner.affiliateProgram')}</li>
    <li>{t('partnerships.waysToPartner.resellerAgreements')}</li>
    <li>{t('partnerships.waysToPartner.apiIntegration')}</li>
    <li>{t('partnerships.waysToPartner.corporatePackages')}</li>
  </ul>

  <p>
    {t('partnerships.contactText')} 
    <a href={`mailto:${t('partnerships.contactEmail')}`}> <span className='emial'>{t('partnerships.contactEmail')}</span></a>
    &nbsp;{t('partnerships.contactEnd')}
  </p>
  </div>
</section>

    </>
  );
}

export default Partnerships;
